export default "__VITE_ASSET__Cn$lHNKM__"